import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import Comments from "../Comments/Comment";
import { Button, Overlay, OverlayTrigger, Popover, Row, Table, Form } from "react-bootstrap";
import emailIcon from "../../../../Assets/Images/Email.svg";
import { useParams } from "react-router-dom";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import { compName, month } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import moment from "moment";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { MultiSelect } from "primereact/multiselect";
import Loader from "../../../Loader/Loader";
import filter from "../../../../Assets/Images/Configuration/filter-icon.svg";
import Filter_MonthDowRoomTypeRatePlanChannels_With_Year from "./Models/Filter_MonthDowRoomTypeRatePlanChannels_With_Year";
import { Line } from "react-chartjs-2";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    Filler,
} from "chart.js";
import ChartDataAsTable from "../ChartDataAsTable";
import horizobtalBarIcon from "../../../../Assets/Images/Revenue-management/horizontal-bars.svg";
import graphIcon from "../../../../Assets/Images/Revenue-management/graphIcon.svg";
const RNXAnalysis2_RevenuAdrNight = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
    topfilterdata,
    topviewoption
}) => {
    const [viewOption, setViewOption] = useState("Graph");

    useEffect(() => {
        if (topviewoption) {
            setViewOption(topviewoption)
        }
    }, [topviewoption]);

    const [SelectedOption, setSelectedOption] = useState("Room Revenue");


    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => { setWidgetModal(false); };

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
        id2: commonService.GenerateGUID(),
        id3: commonService.GenerateGUID(),
        id4: commonService.GenerateGUID(),
    });

    const [filterData, setFilterData] = useState({ year: new Date().getFullYear(), months: [], dow: [], ratecodes: [], roomtypes: [], combinedchannels: [] });

    const [CurrentYearData, setCurrentYearData] = useState([]);

    const [LastYearData, setLastYearData] = useState([]);

    const [FinalData, setFinalData] = useState({
        data: {
            labels: [],
            datasets: []
        },
        options: {

        }
    });

    const GetCurrentYearData = async () => {
        setCurrentYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_MONTH_WISE_SUMMARY,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setCurrentYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const GetLastYearData = async () => {
        setLastYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.RNX.RNX_MONTH_WISE_SUMMARY_STLY,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setLastYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const [dataLoading, setDataLoading] = useState(false);

    const GetAllData = async () => {
        setDataLoading(true);
        await GetCurrentYearData();
        await GetLastYearData();
        setDataLoading(false);
    };

    useEffect(() => {
        if (api === 0) {

        } else {
            if (para?.asOfDate) {
                GetAllData();
            }
        }
    }, [para?.asOfDate, filterData]);

    useEffect(() => {
        if (topfilterdata) {
            setFilterData(topfilterdata)
        }
    }, [topfilterdata]);


    useEffect(() => {
        if (!dataLoading) {
            let _FinalData = {

                data: {
                    labels: [],
                    datasets: []
                },

                options: {
                    interaction: {
                        mode: "index",
                        intersect: false
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: "Room Nights",
                        },
                        legend: {
                            position: "top",
                            align: "end",
                            labels: {
                                boxWidth: 14,
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: function (ctx) {
                                    let value = ctx.raw || 0;
                                    let label = ctx.dataset.label;
                                    return `${label}: ${label.indexOf(" RN") >= 0 ? value : commonService.formateAmount(value)}`;
                                },
                            },
                        },
                    },
                    responsive: true,
                    scales: {
                        y: {
                            type: 'linear',
                            display: true,
                            position: 'left',
                            title: {
                                display: true,
                                text: "Room Nights",
                            },
                            grid: {
                                drawBorder: false
                            }
                        },
                        y1: {
                            type: 'linear',
                            display: true,
                            position: 'right',
                            grid: {
                                drawOnChartArea: false,
                            },
                            title: {
                                display: true,
                                text: "Room Revenue",
                            },
                            ticks: {
                                callback: function (value) {
                                    return commonService.getAmountInCompactFormat(value);
                                },
                            },
                        },
                        x: {
                            grid: {
                                display: false
                            }
                        }
                    }
                }
            };

            let _currentyearroom = {
                label: filterData.year + " RN",
                data: [],
                backgroundColor: "#9c4e98",
                yAxisID: 'y',
                type: "bar",
                datatype: "number"
            }

            let _stlyroom = {
                label: "STLY RN",
                data: [],
                backgroundColor: "#a49d9d",
                yAxisID: 'y',
                type: "bar",
                datatype: "number"
            }

            let _lastyearroom = {
                label: (filterData.year - 1) + " RN",
                data: [],
                backgroundColor: "#ff791d",
                yAxisID: 'y',
                type: "bar",
                datatype: "number"
            }



            let _currentyearadr = {
                label: filterData.year + " ADR",
                data: [],
                backgroundColor: "#3565fc",
                borderColor: "#3565fc",
                yAxisID: 'y1',
                type: "line",
                tension: 0.45,
                pointRadius: 4,
                datatype: "amount"
            }

            let _stlyadr = {
                label: 'STLY ADR',
                data: [],
                backgroundColor: "#de9234",
                borderColor: "#de9234",
                yAxisID: 'y1',
                type: "line",
                tension: 0.45,
                pointRadius: 4,
                datatype: "amount"
            }

            let _lastyearadr = {
                label: (filterData.year - 1) + " ADR",
                data: [],
                backgroundColor: "#4a84c2",
                borderColor: "#4a84c2",
                yAxisID: 'y1',
                type: "line",
                tension: 0.45,
                pointRadius: 4,
                datatype: "amount"
            }


            let _currentyearrevenu = {
                label: filterData.year + " REV",
                data: [],
                backgroundColor: "#3565fc",
                borderColor: "#3565fc",
                yAxisID: 'y1',
                type: "line",
                tension: 0.45,
                pointRadius: 4,
                datatype: "amount"
            }

            let _stlyrevenu = {
                label: 'STLY REV',
                data: [],
                backgroundColor: "#de9234",
                borderColor: "#de9234",
                yAxisID: 'y1',
                type: "line",
                tension: 0.45,
                pointRadius: 4,
                datatype: "amount"
            }

            let _lastyearrevenu = {
                label: (filterData.year - 1) + " REV",
                data: [],
                backgroundColor: "#4a84c2",
                borderColor: "#4a84c2",
                yAxisID: 'y1',
                type: "line",
                tension: 0.45,
                pointRadius: 4,
                datatype: "amount"
            }


            month.map((m) => {
                _FinalData.data.labels.push(m);

                let currentyearroom = 0, currentyearadr = 0, currentyearrev = 0, stlyroom = 0, stlyrev = 0, stlyadr = 0, lastyearroom = 0, lastyearrev = 0, lastyearadr = 0;

                let CD = CurrentYearData.filter((d) => d.monthname.toUpperCase() === m.substr(0, 3).toUpperCase())

                if (CD && CD.length > 0) {
                    currentyearroom = CD[0].total_roomnights ? parseInt(CD[0].total_roomnights) : 0;
                    currentyearrev = CD[0].total_revenue ? parseInt(CD[0].total_revenue) : 0;
                    currentyearadr = CD[0].adr ? parseInt(CD[0].adr) : 0;

                    lastyearroom = CD[0].lastyear_total_roomnights ? parseInt(CD[0].lastyear_total_roomnights) : 0;
                    lastyearrev = CD[0].lastyear_total_revenue ? parseInt(CD[0].lastyear_total_revenue) : 0;
                    lastyearadr = CD[0].lastyear_adr ? parseInt(CD[0].lastyear_adr) : 0;

                }

                let LD = LastYearData.filter((d) => d.monthname.toUpperCase() === m.substr(0, 3).toUpperCase())

                if (LD && LD.length > 0) {

                    stlyroom = LD[0].stly_total_roomnights ? parseInt(LD[0].stly_total_roomnights) : 0;
                    stlyrev = LD[0].stly_total_revenue ? parseInt(LD[0].stly_total_revenue) : 0;
                    stlyadr = LD[0].stly_adr ? parseInt(LD[0].stly_adr) : 0;
                }

                _currentyearroom.data.push(currentyearroom);
                _lastyearroom.data.push(lastyearroom);
                _stlyroom.data.push(stlyroom);


                _currentyearadr.data.push(currentyearadr);
                _lastyearadr.data.push(lastyearadr);
                _stlyadr.data.push(stlyadr);


                _currentyearrevenu.data.push(currentyearrev);
                _lastyearrevenu.data.push(lastyearrev);
                _stlyrevenu.data.push(stlyrev);
            });



            if (SelectedOption === "Room Revenue") {
                _FinalData.options.scales.y1.title.text = "Room Revenue";
                _FinalData.data.datasets.push(_currentyearrevenu)
                _FinalData.data.datasets.push(_stlyrevenu)
                _FinalData.data.datasets.push(_lastyearrevenu)
            }
            else {
                _FinalData.options.scales.y1.title.text = "ADR";
                _FinalData.data.datasets.push(_currentyearadr)
                _FinalData.data.datasets.push(_stlyadr)
                _FinalData.data.datasets.push(_lastyearadr)
            }

            _FinalData.data.datasets.push(_currentyearroom)
            _FinalData.data.datasets.push(_stlyroom)
            _FinalData.data.datasets.push(_lastyearroom)
            setFinalData(_FinalData);
        }
    }, [dataLoading, SelectedOption]);

    const [DisplayFilter, setDisplayFilter] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const ShowFilter = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setDisplayFilter({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const CloseFilter = (data) => {
        setDisplayFilter({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
        setFilterData(data)
    };

    return (
        <div
            className="widget-container"
            style={{ position: "relative", padding: "0 5px" }}
        >
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    {
                        viewOption === "Graph" ?
                            <Button id={commonService.generateGlobalClickTrackerID("RNXAnalysis2_RevenuAdrNight", "table", propertyCode)} className="heading-menu-btns" type="button" title="Table"
                                onClick={(e) => {
                                    setViewOption("Table")
                                }}>
                                <img
                                    src={horizobtalBarIcon}
                                    alt="Table"
                                />
                            </Button>
                            :
                            <Button id={commonService.generateGlobalClickTrackerID("RNXAnalysis2_RevenuAdrNight", "graph", propertyCode)} className="heading-menu-btns" type="button" title="Graph"
                                onClick={(e) => {
                                    setViewOption("Graph")
                                }}>
                                <img
                                    src={graphIcon}
                                    alt="Graph"
                                />
                            </Button>
                    }
                    {
                        !topfilterdata &&
                        <Button id={commonService.generateGlobalClickTrackerID("RNXAnalysis2_RevenuAdrNight", "filter", propertyCode)} className="heading-menu-btns" type="button" title="Filter"
                            onClick={(e) => {
                                ShowFilter(e);
                            }}>
                            <img
                                src={filter}
                                alt="Filter"
                            />
                        </Button>
                    }
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis2_RevenuAdrNight", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1,
                                    "Snapshot By Month",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis2_RevenuAdrNight", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.annualSummary,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis2_RevenuAdrNight", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={
                                tblids.id1
                            }
                            onClick={() => {
                                commonService.fnExportInCSV(
                                    tblids.id1,
                                    `${para?.propertyCode}-Annual Summary-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                );
                            }}
                        />
                    </Button>
                    {
                        DisplayFilter.IsDisplay &&
                        <Overlay
                            show={DisplayFilter.IsDisplay}
                            target={DisplayFilter.Target}
                            placement={DisplayFilter.Position}
                        >
                            <Popover
                                id="popover-contained"
                                className="FilterPopover"
                            >
                                <Filter_MonthDowRoomTypeRatePlanChannels_With_Year show={DisplayFilter.IsDisplay} closeModal={CloseFilter} para={para} dropdownSelectedData={filterData} />
                            </Popover>
                        </Overlay>
                    }
                </div>
            )}
            <div class="d-flex gap-2 align-items-center">
                <div className="form-groups form-groups-radio-btn">
                    <div className="form-groups-radio">
                        <div className="form-radio">
                            <input
                                type="radio"
                                className="form-check-input"
                                name="radioGroup2"
                                value="Revenue"
                                id="Revenue"
                                checked={SelectedOption === "Room Revenue" ? true : false}
                                onClick={() => {
                                    setSelectedOption("Room Revenue");
                                }}
                            />
                            <Form.Check.Label htmlFor="Revenue" className="label-radio">
                                Room Revenue
                            </Form.Check.Label>
                        </div>
                        <div className="form-radio">
                            <input
                                type="radio"
                                className="form-check-input"
                                name="radioGroup2"
                                value="Room Sold"
                                id="RoomSold"
                                checked={SelectedOption === "ADR" ? true : false}
                                onClick={() => {
                                    setSelectedOption("ADR");
                                }}
                            />
                            <Form.Check.Label
                                htmlFor="RoomSold"
                                className="label-radio"
                            >
                                ADR
                            </Form.Check.Label>
                        </div>

                    </div>
                </div>
            </div>
            {
                dataLoading ? <div className="ForecastHorizontalChartInner"> <Loader /></div> :
                    <>{FinalData && (
                        <div className={`TableGraphDataContainer ${viewOption}`}>
                            <div className="ForecastHorizontalChartInner TableGraphDataContainerChart">
                                <Line data={FinalData.data} options={FinalData.options} />
                            </div>
                            <ChartDataAsTable ChartData={FinalData.data} ChartOption={FinalData.options} id={tblids.id1} />
                        </div>
                    )}</>
            }
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            {api !== 0 && !topfilterdata && (
                <Comments widgetDetails={para} editorId={"editor" + tblids.id1} />
            )}
        </div>
    );
};

export default RNXAnalysis2_RevenuAdrNight;
